import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../components/tabs/langController";

// labels
import {FL_DESCRIPTION, FL_SCHEDULE, FL_TITLE, FL_WARNING} from "../../../components/i18n/formLabels";
import {PH_DESCRIPTION, PH_SCHEDULE, PH_TITLE, PH_WARNING} from "../../../components/i18n/placeHolders";

const DynamicModuleLang = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            slogan: '',
            schedule: '',
            description: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>Slogan</Label>
                    <Input
                        type="text"
                        name="slogan"
                        placeholder={'Slogan'}
                        value= { child.slogan }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_SCHEDULE}</Label>
                    <Input
                        type="text"
                        name="schedule"
                        placeholder={PH_SCHEDULE}
                        value= { child.schedule }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        rows="10"
                        name="schedule"
                        placeholder={PH_DESCRIPTION}
                        value= { child.description }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default DynamicModuleLang
